const Quotes = () => {
  return (
    <svg
      width="113"
      height="66"
      viewBox="0 0 113 66"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M111.819 25.7787L111.819 25.7952L111.82 25.8118L111.934 29.4778C111.925 57.0029 90.011 79.3714 62.7752 79.9416L62.7752 67.3394C72.4465 67.0712 81.5033 63.1567 88.3707 56.2536L88.3707 56.2535C89.7407 54.8763 90.991 53.4108 92.119 51.8715L93.6485 49.7841L91.0925 50.1884C89.8372 50.387 88.5508 50.4914 87.2401 50.4914C73.6705 50.4914 62.6607 39.4321 62.6607 25.7787C62.6607 12.1252 73.6705 1.06597 87.2401 1.06597C100.81 1.06597 111.819 12.1252 111.819 25.7787ZM50.2248 25.7787L50.2248 25.7952L50.2253 25.8118L50.3393 29.4778C50.3305 57.0029 28.4166 79.3714 1.18052 79.9416L1.18052 67.3394C10.8516 67.0711 19.9088 63.1567 26.776 56.2536C28.1462 54.8763 29.3966 53.4108 30.5246 51.8715L32.054 49.7841L29.4981 50.1884C28.2428 50.387 26.9564 50.4914 25.6454 50.4914C12.076 50.4914 1.06603 39.4321 1.06603 25.7787C1.06603 12.1252 12.076 1.06598 25.6454 1.06598C39.2148 1.06598 50.2248 12.1252 50.2248 25.7787Z"
        stroke="#D7D6ED"
        strokeWidth="2.13208"
      />
    </svg>
  );
};

export default Quotes;
